import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";
import "../../css/common.css";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_ERROR } from "../../../constants/constants";
const InputField = ({
  value,
  id,
  borderColor,
  label,
  placeholder,
  name,
  required,
  validators,
  type,
  onChange,
  labelClass,
  inputClass,
  labelStyle,
  style,
  disabled,
  spanTitle,
  onKeyPress,
  tabIndex,
  maxLength,
  onKeyUp,
  iconclass,
  getError,
  minLength,
  Error,
  onBlur,
  onWheel,
  max,
  min,
  margin,
  onPaste,
  onDrop,
  onCut,
  onCopy,
  autoComplete,
}) => {
  const [error, setError] = useState(false); 
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch()
  useEffect(() => {}, []);
  const handleChange = (event) => {
    const { value } = event.target;
    if (validateInput(validators, value))
      setError(validateInput(validators, value));
    else if (
      type === "email" &&
      !validateInput(validators, value) &&
      value !== ""
    ) {
      setSuccess(true);
      setError(false);
    } else {
      setError(false);
    }
    onChange(value);
    getError &&
      getError(
        validateInput(validators, value)
          ? validateInput(validators, value)
          : false
      );
  };

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  const preventCopyPaste = (e) => {
    e.preventDefault();
    onReject("Copy paste not allowed!");
  };

  return (
    <>
      {label && (
        <div className={labelClass}>
          <label className="input-label" style={labelStyle}>
            {label}
            {required ? <b className={"text-danger"}> *</b> : ""}
          </label>
        </div>
      )}
      <div className={inputClass}>
        <div className="form-group">
            <div className="input-container">
          <input
            type={type}
            value={value}
            name={name}
            onPaste={onPaste === true ? (e) => preventCopyPaste(e) : ""}
            onDrop={onDrop === true ? (e) => preventCopyPaste(e) : ""}
            onCut={onCut === true ? (e) => preventCopyPaste(e) : ""}
            onCopy={onCopy === true ? (e) => preventCopyPaste(e) : ""}
            autoComplete={autoComplete}
            // className="form-control"
            placeholder={placeholder}
            onChange={handleChange}
            style={style}
            disabled={disabled}
            onKeyPress={onKeyPress}
            tabIndex={tabIndex}
            onKeyUp={onKeyUp}
            onBlur={onBlur}
            pattern={max}
            maxLength={maxLength}
            minLength={minLength}
            iconclass={iconclass}
            id={id}
            min={min}
            onWheel={onWheel}
            className={
              error
                ? "library-input form-control error"
                : success
                ? "library-input form-control success"
                : "library-input form-control"
            }
          ></input>
          {iconclass && <i className={`${iconclass} icon`}></i>}
          </div>
          {spanTitle && <small>{spanTitle}</small>}
          {(error || Error && Error[name]) && <span className={`text-danger errormsg`}>{error.message|| Error[name]}</span>}</div>
      </div>
    </>
  );
};

InputField.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  style: PropTypes.object,
  labelStyle: PropTypes.object,
  iconclass: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
};

InputField.defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  type: "text",
  validators: [],
  labelClass: "col-md-4",
  inputclass: "col-md-6",
  style: {},
  labelStyle: {},
  iconClass: "",
  maxLength: 1000,
  minLength: 0,
};
export default InputField;
